export default "__VITE_ASSET__028efbfb__"